import { useSelector } from 'react-redux'
import { defineMessages, useIntl } from 'react-intl'
import { Dropdown } from '../../../../../Components/shared/Navbar/Dropdown'
import { selectActiveTab } from '../../../../../store/selectors/navigation'
import { FIND_A_HOME_TAB_GROUPING } from '../../../../../mappings/navigation'
import { DesktopHomeSearchLinks } from '../DesktopHomeSearchLinks'
import { DesktopBuyerLinks } from '../DesktopBuyerLinks'

export const FindAHomeDropdown = () => {
  const intl = useIntl()
  const activeTab = useSelector(selectActiveTab)
  const isSelected = FIND_A_HOME_TAB_GROUPING.includes(activeTab)

  const translations = defineMessages({
    label: {
      id: 'DesktopHeader.findAHomeDropdown.label',
      defaultMessage: 'Find a home',
    },
  })

  return (
    <Dropdown
      isSelected={isSelected}
      label={intl.formatMessage(translations.label)}
    >
      <DesktopHomeSearchLinks />
      <DesktopBuyerLinks />
    </Dropdown>
  )
}
